import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './components/App';
import store from './data/redux';
import AppErrorBoundary from './components/error/AppErrorBoundary';

ReactDOM.render(
	<AppErrorBoundary>
		<Provider store={store}>
			<BrowserRouter>
				<App />
			</BrowserRouter>
		</Provider>
	</AppErrorBoundary>,
	document.getElementById('root')
);
